import './css/base-modal.scss';

export const BaseModal = function ({ children }) {
  return (
    <div className="base-modal fixed left0 top0 wh100 flex-center" cy="base-modal">
      {children}
    </div>
  );
};
